export default "__VITE_ASSET__Dr0V$6Pi__"